/*
* (C) Behaviour Interactive Inc. - All Rights Reserved
* Unauthorized copying of this file, via any medium, is strictly prohibited
* This file is proprietary and confidential
*/

import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Avatar, Chip } from '@mui/material';
import { GameIds } from '../../../account/my-games/MyGames.model';
import { useAuth } from '../../../authentication/AuthenticationContext';
import { getProviderLogo } from '../../../account/providers/ProviderLogo';

export default function OwnedOn(): JSX.Element {
  const { t } = useTranslation();
  const { gameId }: { gameId: GameIds } = useParams();
  const auth = useAuth();
  const ownedProviders = auth.user.gameLibrary[gameId]?.providers;

  return (
    <>
      {(!!ownedProviders?.length) && (
        <div>
          <div className='subtitle'>
            <h3>{t('account.game-library.owned-on')}</h3>
          </div>
          <div className='providers-chip-container'>
            {ownedProviders.map(
              (provider) => (
                <Chip
                  label={t(provider)}
                  key={provider}
                  className='provider-chip'
                  avatar={<Avatar alt={provider} src={getProviderLogo(provider)} />}
                />
              ),
            )}
          </div>
        </div>
      )}
    </>
  );
}
